





import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'BlankLayout',
  components: { }
})
export default class extends GiganautVue {
  

}
